import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_CALOCUS_V1 = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_CALOCUS_V1' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader ">I. Risk of Harm</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="radio" id="rb_1_1" name="rb_1" className="add-only" value="1" /> 1. Low Potential for Risk of Harm
                        </td>
                        <td className="w-375">
                            <input type="radio" id="rb_1_2" name="rb_1" className="add-only" value="2" /> 2. Some Potential for Risk of Harm
                        </td>

                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-375">
                            <input type="radio" id="rb_1_3" name="rb_1" className="add-only" value="3" /> 3. Significant Potential for Risk of Harm
                        </td>
                        <td className="w-375">
                            <input type="radio" id="rb_1_4" name="rb_1" className="add-only" value="4" /> 4. Serious Potential for Risk of Harm
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-375">
                            <input type="radio" id="rb_1_5" name="rb_1" className="add-only" value="5" />  5. Extreme Potential for Risk of Harm
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750">
                            Score:
                            &nbsp;
                            <input type='text' id="txtScore_i" name="txtScore_i" className="add-only w-250 custom-add-only" />
                        </td> 
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader ">II. Functional Status </span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_2_1" name="rb_2" className="add-only" value="1" /> 1. Minimal Impairment
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_2_2" name="rb_2" className="add-only" value="2" /> 2. Mild Impairment
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_2_3" name="rb_2" className="add-only" value="3" /> 3. Moderate Impairment
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_2_4" name="rb_2" className="add-only" value="4" /> 4. Serious Impairment
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_2_5" name="rb_2" className="add-only" value="5" /> 5. Severe Impairment
                        </td>
                        <td className="w-250">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            Score:
                            &nbsp;
                            <input type='text' id="txtScore_ii" name="txtScore_ii" className="add-only w-250 custom-add-only" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader ">III. Co-Morbidity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_3_1" name="rb_3" className="add-only" value="1" /> 1. No Co-Morbidity
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_3_2" name="rb_3" className="add-only" value="2" /> 2. Minor Co-Morbidity
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_3_3" name="rb_3" className="add-only" value="3" /> 3. Significant Co-Morbidity
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_3_4" name="rb_3" className="add-only" value="4" /> 4. Major Co-Morbidity
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_3_5" name="rb_3" className="add-only" value="5" /> 5. Severe Co-Morbidity
                        </td>
                        <td className="w-250">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            Score:
                            &nbsp;
                            <input type='text' id="txtScore_iii" name="txtScore_iii" className="add-only w-250 custom-add-only" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader ">IV-A. Recovery Environment - Level of Stress</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="radio" id="rb_4_1" name="rb_4" className="add-only" value="1" /> 1. Minimally Stressful Environment
                        </td>
                        <td className="w-375">
                            <input type="radio" id="rb_4_2" name="rb_4" className="add-only" value="2" /> 2. Mildly Stressful Environment
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="radio" id="rb_4_3" name="rb_4" className="add-only" value="3" /> 3. Moderately Stressful Environment
                        </td>

                        <td className="w-375">
                            <input type="radio" id="rb_4_4" name="rb_4" className="add-only" value="4" /> 4. Highly Stressful Environment
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="radio" id="rb_4_5" name="rb_4" className="add-only" value="5" /> 5. Extremely Stressful Environment
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            Score:
                            &nbsp;
                            <input type='text' id="txtScore_iv_a" name="txtScore_iv_a" className="add-only w-250 custom-add-only" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader ">IV-B. Recovery Environment - Level of Support</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_5_1" name="rb_5" className="add-only" value="1" /> 1. Highly Supportive Environment
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_5_2" name="rb_5" className="add-only" value="2" /> 2. Supportive Environment
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_5_3" name="rb_5" className="add-only" value="3" /> 3. Limited Support in Environment
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_5_4" name="rb_5" className="add-only" value="4" /> 4. Minimal Support in Environment
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_5_5" name="rb_5" className="add-only" value="5" /> 5. No Support in Environment
                        </td>
                        <td className="w-250">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            Score:
                            &nbsp;
                            <input type='text' id="txtScore_iv_b" name="txtScore_iv_b" className="add-only w-250 custom-add-only" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader ">V. Resiliency and Treatment History</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="radio" id="rb_6_1" name="rb_6" className="add-only" value="1" /> 1. Full Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="radio" id="rb_6_2" name="rb_6" className="add-only" value="2" /> 2. Significantly Resilient and/or Response to Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="radio" id="rb_6_3" name="rb_6" className="add-only" value="3" /> 3. Moderate or Equivocal Response to Treatment and Recovery Management
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="radio" id="rb_6_4" name="rb_6" className="add-only" value="4" /> 4. Poor Response to Treatment and Recovery Management
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="radio" id="rb_6_5" name="rb_6" className="add-only" value="5" /> 5. Negligible Response to Treatment
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            Score:
                            &nbsp;
                            <input type='text' id="txtScore_v" name="txtScore_v" className="add-only w-250 custom-add-only" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader ">VI-A. Acceptance and Engagement - Child/Adolescent </span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_7_1" name="rb_7" className="add-only" value="1" />1. Optimal
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_7_2" name="rb_7" className="add-only" value="2" /> 2. Constructive
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_7_3" name="rb_7" className="add-only" value="3" /> 3. Obstructive
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_7_4" name="rb_7" className="add-only" value="4" /> 4. Destructive
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_7_5" name="rb_7" className="add-only" value="5" /> 5. Inaccessible
                        </td>
                        <td className="w-250">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            Score:
                            &nbsp;
                            <input type='text' id="txtScore_vi_a" name="txtScore_vi_a" className="add-only w-250 custom-add-only" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader ">VI-B. Acceptance and Engagement - Parent/Primary Caretaker </span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_8_1" name="rb_8" className="add-only" value="1" /> 1. Optimal
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_8_2" name="rb_8" className="add-only" value="2" /> 2. Constructive
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_8_3" name="rb_8" className="add-only" value="3" /> 3. Obstructive
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_8_4" name="rb_8" className="add-only" value="4" /> 4. Destructive
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_8_5" name="rb_8" className="add-only" value="5" /> 5. Inaccessible
                        </td>
                        <td className="w-250">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            Score:
                            &nbsp;
                            <input type='text' id="txtScore_vi_b" name="txtScore_vi_b" className="add-only w-250 custom-add-only" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Composite Score</span>
                            <input id="txtCompositeScore" type='text' name="txtCompositeScore" className='add-only' />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Level of Care Recommendation</span>
                            <input id="txt_10_1" type='text' name="txt_10_1" className='add-only' />

                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <h5>Scoring Sheet</h5>
                    <h6>Child and Adolescent Level of Care Utilization System </h6>
                </p>

                <p className="w-750">
                    <span className="eleHeader">A. Clinical Level of Care Recommendation
                    </span>
                    <small>(Assign before using CALOCUS)</small>
                    <input id="txtClinicalLevelCare" type='text' name="txtClinicalLevelCare" className="add-only" />
                </p>
                <p className="w-750">
                    <span className="eleHeader">B. Calculation of Composite CALOCUS Score
                    </span>
                    <input id="txtCompositeCalocusScore" type='text' name="txtCompositeCalocusScore" className="add-only" />
                </p>

                <p className="w-750">
                </p>

                <table >

                    <tr>
                        <td className="w-375"><span className="eleHeader">Dimension</span></td>
                        <td className='w-375'><span className="eleHeader">Dimension Rating</span></td>
                    </tr>

                    <tr>
                        <td className="w-375"> 1. Risk of Harm</td>
                        <td className="w-375">
                            <input type='radio' id='rbDimRating_11' name='rbDimRating_1' className='add-only' value='1' /> 1  &nbsp;
                            <input type='radio' id='rbDimRating_12' name='rbDimRating_1' className='add-only' value='2' /> 2  &nbsp;
                            <input type='radio' id='rbDimRating_13' name='rbDimRating_1' className='add-only' value='3' /> 3  &nbsp;
                            <input type='radio' id='rbDimRating_14' name='rbDimRating_1' className='add-only' value='4' /> 4  &nbsp;
                            <input type='radio' id='rbDimRating_15' name='rbDimRating_1' className='add-only' value='5' /> 5  &nbsp;
                            <input type='text' id="txtDimensionRating_1" name="txtDimensionRating_1" className="add-only w-200 custom-add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375"> 2. Functional Status</td>
                        <td className="w-375">
                            <input type='radio' id='rbDimRating_21' name='rbDimRating_2' className='add-only' value='1' /> 1  &nbsp;
                            <input type='radio' id='rbDimRating_22' name='rbDimRating_2' className='add-only' value='2' /> 2  &nbsp;
                            <input type='radio' id='rbDimRating_23' name='rbDimRating_2' className='add-only' value='3' /> 3  &nbsp;
                            <input type='radio' id='rbDimRating_24' name='rbDimRating_2' className='add-only' value='4' /> 4  &nbsp;
                            <input type='radio' id='rbDimRating_25' name='rbDimRating_2' className='add-only' value='5' /> 5  &nbsp;
                            <input type='text' id="txtDimensionRating_2" name="txtDimensionRating_2" className="add-only w-200 custom-add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375"> 3. Co-Morbidity</td>
                        <td className="w-375">
                            <input type='radio' id='rbDimRating_31' name='rbDimRating_3' className='add-only' value='1' /> 1  &nbsp;
                            <input type='radio' id='rbDimRating_32' name='rbDimRating_3' className='add-only' value='2' /> 2  &nbsp;
                            <input type='radio' id='rbDimRating_33' name='rbDimRating_3' className='add-only' value='3' /> 3  &nbsp;
                            <input type='radio' id='rbDimRating_34' name='rbDimRating_3' className='add-only' value='4' /> 4  &nbsp;
                            <input type='radio' id='rbDimRating_35' name='rbDimRating_3' className='add-only' value='5' /> 5  &nbsp;
                            <input type='text' id="txtDimensionRating_3" name="txtDimensionRating_3" className="add-only w-200 custom-add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">4. Recovery Environment  </td>
                    </tr>
                    <tr>
                        <td className="w-50">&nbsp;  </td>
                        <td className="w-325"> Environmental Stressors  </td>
                        <td className="w-375">
                            <input type='radio' id='rbDimRating_4a1' name='rbDimRating_4a' className='add-only' value='1' /> 1  &nbsp;
                            <input type='radio' id='rbDimRating_4a2' name='rbDimRating_4a' className='add-only' value='2' /> 2  &nbsp;
                            <input type='radio' id='rbDimRating_4a3' name='rbDimRating_4a' className='add-only' value='3' /> 3  &nbsp;
                            <input type='radio' id='rbDimRating_4a4' name='rbDimRating_4a' className='add-only' value='4' /> 4  &nbsp;
                            <input type='radio' id='rbDimRating_4a5' name='rbDimRating_4a' className='add-only' value='5' /> 5  &nbsp;
                            <input type='text' id="txtDimensionRating_4a" name="txtDimensionRating_4a" className="add-only w-200 custom-add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-50">&nbsp;  </td>
                        <td className="w-325"> Environmental Support  </td>
                        <td className="w-375">
                            <input type='radio' id='rbDimRating_4b1' name='rbDimRating_4b' className='add-only' value='1' /> 1  &nbsp;
                            <input type='radio' id='rbDimRating_4b2' name='rbDimRating_4b' className='add-only' value='2' /> 2  &nbsp;
                            <input type='radio' id='rbDimRating_4b3' name='rbDimRating_4b' className='add-only' value='3' /> 3  &nbsp;
                            <input type='radio' id='rbDimRating_4b4' name='rbDimRating_4b' className='add-only' value='4' /> 4  &nbsp;
                            <input type='radio' id='rbDimRating_4b5' name='rbDimRating_4b' className='add-only' value='5' /> 5  &nbsp;
                            <input type='text' id="txtDimensionRating_4b" name="txtDimensionRating_4b" className="add-only w-200 custom-add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375"> 5. Resiliency and Treatment History </td>
                        <td className="w-375">
                            <input type='radio' id='rbDimRating_51' name='rbDimRating_5' className='add-only' value='1' /> 1  &nbsp;
                            <input type='radio' id='rbDimRating_52' name='rbDimRating_5' className='add-only' value='2' /> 2  &nbsp;
                            <input type='radio' id='rbDimRating_53' name='rbDimRating_5' className='add-only' value='3' /> 3  &nbsp;
                            <input type='radio' id='rbDimRating_54' name='rbDimRating_5' className='add-only' value='4' /> 4  &nbsp;
                            <input type='radio' id='rbDimRating_55' name='rbDimRating_5' className='add-only' value='5' /> 5  &nbsp;
                            <input type='text' id="txtDimensionRating_5" name="txtDimensionRating_5" className="add-only w-200 custom-add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375"> 6. Acceptance and Engagement </td>
                    </tr>
                    <tr>
                        <td className="w-50">&nbsp;  </td>
                        <td className="w-325"> Child/Adolescent </td>
                        <td className="w-375">
                            <input type='radio' id='rbDimRating_6a1' name='rbDimRating_6a' className='add-only' value='1' /> 1  &nbsp;
                            <input type='radio' id='rbDimRating_6a2' name='rbDimRating_6a' className='add-only' value='2' /> 2  &nbsp;
                            <input type='radio' id='rbDimRating_6a3' name='rbDimRating_6a' className='add-only' value='3' /> 3  &nbsp;
                            <input type='radio' id='rbDimRating_6a4' name='rbDimRating_6a' className='add-only' value='4' /> 4  &nbsp;
                            <input type='radio' id='rbDimRating_6a5' name='rbDimRating_6a' className='add-only' value='5' /> 5  &nbsp;
                            <input type='text' id="txtDimensionRating_6a" name="txtDimensionRating_6a" className="add-only w-200 custom-add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-50">&nbsp;  </td>
                        <td className="w-325"> Parent and/or Primary Care Taker  </td>
                        <td className="w-375">
                            <input type='radio' id='rbDimRating_6b1' name='rbDimRating_6b' className='add-only' value='1' /> 1  &nbsp;
                            <input type='radio' id='rbDimRating_6b2' name='rbDimRating_6b' className='add-only' value='2' /> 2  &nbsp;
                            <input type='radio' id='rbDimRating_6b3' name='rbDimRating_6b' className='add-only' value='3' /> 3  &nbsp;
                            <input type='radio' id='rbDimRating_6b4' name='rbDimRating_6b' className='add-only' value='4' /> 4  &nbsp;
                            <input type='radio' id='rbDimRating_6b5' name='rbDimRating_6b' className='add-only' value='5' /> 5  &nbsp;
                            <input type='text' id="txtDimensionRating_6b" name="txtDimensionRating_6b" className="add-only w-200 custom-add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-750"><i>(Note: please record the higher of the two scores)</i>  </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Note: <strong>Bold</strong> indicates independent criteria-requires automatic admission to a higher level of care regardless of
                    combined score. A score of 4 results in placement at level 5 and a score of 5 results in placement at level six.<br />
                    * = independent criteria may be waived if sum of IV-A and IV-B scores equal 2.
                </p>

                <p className='w-750'>
                    <h6>COMPOSITE CALOCUS SCORES </h6>
                    <small>(add right column)</small>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">C. CALOCUS Derived Level of Care Recommendation (Consult Grid and Decision Tree) </span>
                    <input id="txtDerivedLevelCare" type='text' name="txtDerivedLevelCare" className="add-only" />
                </p>
                <p className='w-750'>
                    <span className="eleHeader">D. Actual (Disposition) Level of Care </span>
                    <input id="txtActualLevelCare" type='text' name="txtActualLevelCare" className="add-only" />
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Reason for Variance from CALOCUS Level of Care Recommendation </span>
                    <textarea id="txtReasonForVariance" name="txtReasonForVariance" ></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Date of Scoring</span>
                            <input id="txtDateScoring" name="txtDateScoring" type='date' className="add-only" />

                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Name of Scorer</span>
                            <input id="txtNameScorer" type='text' name="txtNameScorer" className="add-only" />

                        </td>
                    </tr>
                </table>
            </div>

        </form >
    )
}